<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IRestaurant } from '@/interfaces/IRestaurant';
  import SimpleScrollableModal from '../base/SimpleScrollableModal.vue';
  import ItemsService from '@/api/services/items.service';
  import { IItem } from '@/interfaces/IItem';
  import CategoriesService from '@/api/services/categories.service';
  import RestaurantsService from '@/api/services/restaurants.service';
  import { ICategory } from '@/interfaces/ICategory';

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class StickerViewLabelModal extends Vue {
    @Prop() item: IItem;

    async created() {}
  }
</script>

<template>
  <simple-scrollable-modal>
    <template #title>
      <h3>Etiqueta</h3>
    </template>
    <template #content>
      <v-textarea
        v-model="item.labelTemplate"
        label="Etiqueta"
        readonly
        outlined
        dense
        rows="5"
        hide-details
        placeholder="Escriba aquí la etiqueta"
        background-color="#f2f2f2"
      ></v-textarea
    ></template>
    <template #action-bar>
      <div class="d-flex flex-row justify-end">
        <v-btn color="danger" text depressed @click="$emit('close')">
          Cerrar
        </v-btn>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<style scoped lang="scss"></style>
